import { Component, OnInit, Input, Output, EventEmitter, ViewChild, Optional, Inject, ElementRef } from "@angular/core";
import { FormGroup, FormBuilder, FormArray, Validators } from "@angular/forms";
import { MenuComponent } from "../../../inputs/menu/menu.component";
import {
  NgModel,
  NG_VALUE_ACCESSOR,
  NG_VALIDATORS,
  NG_ASYNC_VALIDATORS,
} from '@angular/forms';
import { ElementBase } from "src/app/core/form/element-base";
@Component({
  selector: 'app-inpt-meses',
  templateUrl: './meses.component.html',
  styleUrls: ['./meses.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: InptMesesComponent,
      multi: true
    }
  ],
})
export class InptMesesComponent extends ElementBase<any> implements OnInit {
  @Input() mobileMode: boolean;
  @Input() airLines: any = false;
  @Input() class: String = 'py-3';
  @Input() height: String = '56px';
  @Input() submited: boolean;
  @Input() placeholder: boolean;
  @Output() formUpdate: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild(MenuComponent) menu: MenuComponent;
  @ViewChild(NgModel) model: NgModel;
  @ViewChild('tg') tg: MenuComponent;
  // public huespedes: any = 0;
  public form: FormGroup;
  public habitCount: number;
  public totalAdultos: any = 0;
  public edadesPermision: any = [];
  public meses = [
    {value: 'JANUARY', label: 'Enero'},
    {value: 'FEBRUARY', label: 'Febrero'},
    {value: 'MARCH', label: 'Marzo'},
    {value: 'APRIL', label: 'Abril'},
    {value: 'MAY', label: 'Mayo'},
    {value: 'JUNE', label: 'Junio'},
    {value: 'JULY', label: 'Julio'},
    {value: 'AUGUST', label: 'Agosto'},
    {value: 'SEPTEMBER', label: 'Septiembre'},
    {value: 'OCTOBER', label: 'Octubre'},
    {value: 'NOVEMBER', label: 'Noviembre'},
    {value: 'DECEMBER', label: 'Diciembre'}
  ];
  constructor(
    @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
    @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
    private fb: FormBuilder) {
      super(validators, asyncValidators);
  }
  ngOnInit() {
    let hoy = new Date().getMonth();
    let year = new Date().getFullYear()+1;
    for(let i=0; i < hoy; i++){
      this.meses[i].label = this.meses[i].label + " " + year;
    }
  }
  changeValueMes(val) {
    this.value = val;
    this.menu.closeMenu();
  }

  checkFocus() {
    this.tg.openMenu();
  }

}
